<div class="feedback-overlay" *ngIf="isVisible" (click)="closeFeedback()">
  <div class="feedback-card" (click)="$event.stopPropagation()">
    <div class="feedback-header">
      <div class="feedback-heading">
        <h3 class="feedback-title">Feedback</h3>
        <p class="feedback-subtitle">Share a quick rating and note for this response.</p>
      </div>
      <button class="close-btn" type="button" aria-label="Close" (click)="closeFeedback()">
        <img src="assets/icons/close-icon.svg" alt="Close">
      </button>
    </div>

    <div class="feedback-section">
      <label class="section-label">Rating</label>
      <div class="stars" role="radiogroup" aria-label="Feedback rating">
        <button
          *ngFor="let star of stars"
          type="button"
          class="star-btn"
          [class.filled]="star <= rating"
          [attr.aria-label]="'Rate ' + star + ' out of 5'"
          (click)="setRating(star)">
          &#9733;
        </button>
      </div>
      <p class="rating-text">{{ rating }} out of 5</p>
      <p class="error" *ngIf="showValidation && rating === 0 ">
        Please select a rating.
      </p>
    </div>

    <div class="feedback-section">
      <label class="section-label" for="feedbackMessage">Feedback Message</label>
      <textarea
        id="feedbackMessage"
        class="feedback-textarea"
        placeholder="Share your feedback..."
        [(ngModel)]="additionalFeedback"
        maxlength="500">
      </textarea>
      <p class="char-counter">{{ additionalFeedback.length }}/500</p>
      <p class="error" *ngIf="showValidation && !additionalFeedback.trim()">
        Please enter your feedback.
      </p>
    </div>

    <div class="feedback-actions">
      <button class="btn btn-secondary" type="button" (click)="closeFeedback()">Cancel</button>
      <button class="btn btn-primary" type="button" (click)="submitFeedback()">Submit Feedback</button>
    </div>
  </div>
</div>
